<template>
    <div id="app">
        <Navigation v-if="currentUser"></Navigation>
    	<router-view/>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import Navigation from './components/Navigation.vue'
    import ItemBox from './components/ItemBox'
    import ItemHeadBox from './components/ItemHeadBox'
    import ItemRow from './components/ItemRow'

    export default {
        components: { Navigation, ItemBox, ItemRow, ItemHeadBox},
        computed: {
            ...mapState(['currentUser'])
        }
    }
</script>



// WEBPACK FOOTER //
// src/App.vue